// extracted by mini-css-extract-plugin
export var container = "_68-0";
export var infoButton = "_68-1";
export var label = "_68-3";
export var labelExpanded = "_68-4";
export var price = "_68-5";
export var priceExpanded = "_68-6";
export var title = "_68-2";